import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import '@librerank/ui/src/globals.css'
import './index.css'
import App from './App.tsx'
import { ConvexClientProvider } from './ConvexClientProvider.tsx'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <ConvexClientProvider>
        <App />
      </ConvexClientProvider>
    </BrowserRouter>
  </StrictMode>,
)
